import { useTranslation } from "react-i18next";
import { ClipboardList } from "lucide-react";
import { TaskCard } from "./TaskCard";

export const TaskList = ({ rows, loading, userId, canManage, ...handlers }) => {
  const { t } = useTranslation();
  if (loading) {
    return (
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="task-list-loading">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="h-56 animate-pulse rounded-3xl bg-muted/50 shadow-neu-sm" />
        ))}
      </div>
    );
  }
  if (!rows.length) {
    return (
      <div className="grid place-items-center gap-3 rounded-3xl bg-background p-12 text-center shadow-neu-in" data-testid="task-empty">
        <ClipboardList className="h-10 w-10 text-muted-foreground" />
        <p className="text-sm font-bold text-muted-foreground">{t("tasks.empty")}</p>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid="task-list">
      {rows.map((task) => (
        <TaskCard key={task.id} task={task} userId={userId} canManage={canManage} {...handlers} />
      ))}
    </div>
  );
};
